export default __webpack_public_path__ + "static/media/terras-eethoek.6682b78a.jpg";